import moment from 'moment';

class CalendarEvents {
    _localDate = moment().clone().startOf('year');
    _thisDate = moment().clone().format('M');
    _inner;
    _buttons;

    constructor(options) {
        this.element = options.element;
        this._inner = this.element.querySelector('.swiper-wrapper', 'slider__wrapper');

        this.#init()
    }

    #init() {
        if (this._inner.querySelector('.swiper-slide')) {
            this._inner.querySelectorAll('.swiper-slide').forEach(item => {
                item.remove()
            })
        }

        let count = 15;
        for (let i = 0; i < count; i++) {
            this._localDate = this.#newMonth(this._localDate);
        }

        if (window.calendarEvents.slider) {
            window.calendarEvents.slider.update();
            window.calendarEvents.slider.slideTo(this._thisDate - 1, 0);
        }

        this._buttons = this.element.querySelectorAll('.jsFilterMonth');
        this.#buttons();
    }

    #buttons() {
        let that = this;

        function clearAll() {
            that._buttons.forEach(item => {
                item.classList.remove('is-active')
            })
        }

        this._buttons.forEach((item, index) => {

            if (index == (this._thisDate - 1)) {
                item.classList.add('is-active')
                click()
            }

            item.addEventListener('click', () => {
                click()
            })

            function click() {
                let value = item.getAttribute('data-calendar-date');
                clearAll()

                item.classList.add('is-active')

                if (item.closest('.filter')) {
                    item.closest('.filter').querySelector('input[name="date_from"').value = value
                }

                window.datepickerChange(item)
            }
        })
    }

    #newMonth(localDate) {
        const tempDate = localDate.clone();
        const monthStart = localDate.clone();
        const monthEnd = tempDate.clone().endOf('month');
        const monthName = tempDate.format('MMMM');

        // Создание и наполнение
        let slide = document.createElement('div');
        let month = document.createElement('div');

        slide.classList.add('swiper-slide', 'slider__slide');
        month.classList.add('calendar-events__item', 'jsFilterMonth');
        month.innerHTML = `<span>` + monthName + `</span>`;
        month.setAttribute('data-calendar-date', monthStart.format('YYYY-MM-DD'));
        slide.append(month)
        this._inner.append(slide)

        return monthEnd.add(1, 'day');
    }
}

window.CalendarEvents = CalendarEvents;

export default CalendarEvents;
